import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { Button } from "@zendesk/self-service-components";
import { Spinner } from "@zendeskgarden/react-loaders";
import AutocompleteItem from "./components/AutocompleteItem";
import classNames from "classnames";
import styles from "./index.css";

export default class AutocompleteList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
    };

    this.onAddNew = this.onAddNew.bind(this);
    this.onRemoveNew = this.onRemoveNew.bind(this);
    this.onShowNew = this.onShowNew.bind(this);
  }

  onAddNew(newItem) {
    const { onAddNew } = this.props;

    this.setState({ showNew: false });
    onAddNew(newItem);
  }

  onRemoveNew() {
    this.setState({ showNew: false });
  }

  onShowNew() {
    this.setState({ showNew: true });
  }

  render() {
    const { showNew } = this.state;
    const {
      items,
      type,
      conjunction,
      newText,
      isLoading,
      title,
      description,
      error,
    } = this.props;

    if (isLoading) {
      return (
        <div className={styles.itemWrapper}>
          <h3 className={styles.itemHeader}>{title}</h3>
          <p
            className={styles.itemDescription}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <div className={styles.list}>
            <div className={styles.loader}>
              <Spinner />
            </div>
          </div>
        </div>
      );
    }

    const newItem = [
      items.length > 0 && (
        <span key="newConj" className={styles.conjunction}>
          {conjunction}
        </span>
      ),
      <AutocompleteItem
        newItem
        key="newItem"
        type={type}
        onNewAdd={this.onAddNew}
        onNewRemove={this.onRemoveNew}
      />,
    ];

    const newButton = (
      <Button
        testId={`add-new-${type}`}
        type="anchor"
        className={classNames(styles.conjunction, {
          [styles.onlyNewButton]: items.length === 0,
        })}
        onClick={this.onShowNew}
      >
        {newText}
      </Button>
    );

    return (
      <div className={styles.itemWrapper}>
        <h3 className={styles.itemHeader}>{title}</h3>
        <p
          className={styles.itemDescription}
          dangerouslySetInnerHTML={{ __html: description }}
        />

        {error ? (
          <div className={styles.error}>{error}</div>
        ) : (
          <div className={styles.list}>
            {items.reduce((acc, item) => {
              const id = item.id || item;

              return [
                ...acc,
                acc.length !== 0 && (
                  <span
                    key={`${conjunction}-${id}`}
                    className={styles.conjunction}
                  >
                    {conjunction}
                  </span>
                ),
                <AutocompleteItem key={id} type={type} item={item} />,
              ];
            }, [])}

            {showNew ? newItem : newButton}
          </div>
        )}
      </div>
    );
  }
}

AutocompleteList.defaultProps = {
  items: [],
  isLoading: false,
};

AutocompleteList.propTypes = {
  items: PropTypes.array,
  type: PropTypes.oneOf(["tags", "groups", "organizations"]),
  conjunction: PropTypes.string,
  newText: PropTypes.string,
  onAddNew: PropTypes.func,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/AutocompleteList/index.js